import { Injectable } from '@angular/core';
import { WebApiService } from '../../../shared/services/web-api.service';
import { HttpHeaders } from '@angular/common/http';
import { PoTokenAuthService } from 'src/app/shared/services/po-token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  constructor(
    private webApiService: WebApiService,
    private poTokenAuth: PoTokenAuthService
    ) { }
    
  savePurchaseOrder(params: any): Promise<any> {
    let apiUrl = `/purchaseOrder/savePurchaseOrder`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  createPurchaseOrder(params: any): Promise<any> {
    let apiUrl = `/purchaseOrder/createPurchaseOrder`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  updatePurchaseOrder(params: any): Promise<any> {
    let apiUrl = `/purchaseOrder/updatePurchaseOrder`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }
  
  fetchPurchaseOrder(params:any):Promise<any>{
    let apiUrl = `/purchaseOrder/fetchPurchaseOrder`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  deletePOAttachment(reqBody: any): Promise<any> {
    let apiUrl = `/purchaseOrder/deletePOAttachment`;
    return this.webApiService.postRequest<any>(apiUrl, reqBody);
  }

  fetchPurchaseOrderByPoToken(params:any):Promise<any>{
    const apiUrl = `/purchaseOrder/fetchPurchaseOrderByPoToken`;
    // Ensure purchaseOrderId matches the verified token's poId when possible
    const poId = this.poTokenAuth.getPoId();
    const requestBody = {
      ...params,
      ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
    };

    const token = this.poTokenAuth.getToken();
    const options = token
      ? { headers: new HttpHeaders().set('Authorization', 'Bearer ' + token) }
      : {};

    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  updatePurchaseOrderFreightForwarder(params: any): Promise<any> {
    let apiUrl = `/purchaseOrder/updatePurchaseOrderFreightForwarder`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }
  
  fetchAllPurchaseOrderByBuyerId(
      filterValue: string,
      buyerId: number,
      docStatus: string,
      fromDate: any,
      toDate: any,
      sortField: string,
      sortDir: string,
      limit: number,
      offset: number,
      isActive: number,
      operationType: string
    ): Promise<any> {

      let apiUrl = `/purchaseOrder/fetchAllPurchaseOrderByBuyerId`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        {
          limit,
          offset,
          filterValue,
          sortField,
          sortDir,
          buyerId,
          docStatus,
          fromDate,
          toDate,
          isActive,
          operationType,
        }
      );
    }


  purchaseOrderListOperations(params: any): Promise<any> {
    let apiUrl = `/purchaseOrder/purchaseOrderListOperations`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        params
      );
    }

   fetchAllPurchaseOrderBySupplierId(
      filterValue: string,
      supplierId: number,
      docStatus: string,
      fromDate: any,
      toDate: any,
      sortField: string,
      sortDir: string,
      limit: number,
      offset: number,
      isActive: number,
      operationType: string
    ): Promise<any> {

      let apiUrl = `/purchaseOrder/fetchAllPurchaseOrderBySupplierId`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        {
          limit,
          offset,
          filterValue,
          sortField,
          sortDir,
          supplierId,
          docStatus,
          fromDate,
          toDate,
          isActive,
          operationType,
        }
      );
    }
    sendPoConfirmationForBuyerAndSupplier(params: any): Promise<any> {
      let apiUrl = `/purchaseOrder/sendPoConfirmationForBuyerAndSupplier`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        params
      );
    }

    getLastAcceptedOrderId(): Promise<any> {
      let apiUrl = `/purchaseOrder/getLastAcceptedOrderId`;
      return this.webApiService.getRequest<any>(apiUrl);
    }

    getLastAcceptedOrderIdByPoToken(): Promise<any> {
      const apiUrl = `/purchaseOrder/getLastAcceptedOrderIdByPoToken`;
      const options = this.poTokenAuth.buildAuthHeaders();
      return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
    }

  fetchAllRejectionReason(): Promise<any> {
    let apiUrl = `/purchaseOrder/fetchAllRejectionReason`;
    return this.webApiService.getRequest<any>(apiUrl);
  }
  fetchAllRejectionReasonByPoToken(): Promise<any> {
      const apiUrl = `/purchaseOrder/fetchAllRejectionReasonPoToken`;
      const token = this.poTokenAuth.getToken();
      const options = token
        ? { headers: new HttpHeaders().set('Authorization', 'Bearer ' + token) }
        : {};
      return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
    }

    sendPurchaseOrderConfirmationAcknowledgement(params: any): Promise<any> {
      let apiUrl = `/purchaseOrder/sendPurchaseOrderConfirmationAcknowledgement`;
        return this.webApiService.postRequest<any>(
          apiUrl,
          params
        );
    }
    sendPurchaseOrderConfirmationAcknowledgementByPoToken(params: any): Promise<any> {
      const apiUrl = `/purchaseOrder/sendPurchaseOrderConfirmationAcknowledgementByPoToken`;
      const poId = this.poTokenAuth.getPoId();
      const requestBody = {
        ...params,
        ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
      };
      const options = this.poTokenAuth.buildAuthHeaders();
      return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
    }

    sendPurchaseOrderRejectionAcknowledgement(params: any): Promise<any> {
      let apiUrl = `/purchaseOrder/sendPurchaseOrderRejectionAcknowledgement`;
        return this.webApiService.postRequest<any>(
          apiUrl,
          params
        );
    }
    sendPurchaseOrderRejectionAcknowledgementByPoToken(params: any): Promise<any> {
      const apiUrl = `/purchaseOrder/sendPurchaseOrderRejectionAcknowledgementByPoToken`;
      const poId = this.poTokenAuth.getPoId();
      const requestBody = {
        ...params,
        ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
      };
      const options = this.poTokenAuth.buildAuthHeaders();
      return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
    }

    generateSupplierPoAttachment(params: any): Promise<any> {
      let apiUrl = `/purchaseOrder/generateSupplierPoAttachment`;
        return this.webApiService.postRequest<any>(
          apiUrl,
          params
        );
    }
    generateSupplierPoAttachmentByPoToken(params: any): Promise<any> {
      const apiUrl = `/purchaseOrder/generateSupplierPoAttachmentByPoToken`;
      const poId = this.poTokenAuth.getPoId();
      const requestBody = {
        ...params,
        ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
      };
      const options = this.poTokenAuth.buildAuthHeaders();
      return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
    }

    fetchAllPurchaseOrderApprovalByBuyerId(
      filterValue: string,
      buyerId: number,
      docStatus: string,
      fromDate: any,
      toDate: any,
      sortField: string,
      sortDir: string,
      limit: number,
      offset: number,
      isActive: number,
      operationType: string
    ): Promise<any> {

      let apiUrl = `/purchaseOrder/fetchAllPurchaseOrderApprovalByBuyerId`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        {
          limit,
          offset,
          filterValue,
          sortField,
          sortDir,
          buyerId,
          docStatus,
          fromDate,
          toDate,
          isActive,
          operationType,
        }
      );
    }

    fetchPurchaseOrderApprovalDetailsByPoId(params: any): Promise<any> {
      let apiUrl = `/purchaseOrder/fetchPurchaseOrderApprovalDetailsByPoId`;
        return this.webApiService.postRequest<any>(
          apiUrl,
          params
        );
    }


    updatePurchaseOrderApprovalDetailsByApproverId(params: any): Promise<any> {
      let apiUrl = `/purchaseOrder/updatePurchaseOrderApprovalDetailsByApproverId`;
        return this.webApiService.postRequest<any>(
          apiUrl,
          params
        );
    }


  fetchPurchaseOrderDetailsAndSendPO(params:any):Promise<any>{
    let apiUrl = `/purchaseOrder/fetchPurchaseOrderDetailsAndSendPO`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }


  generatePoPdf(params:any):Promise<any>{
    let apiUrl = `/purchaseOrder/generatePoPdf`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  fetchPoAttachmentExcelData(params:any):Promise<any>{
    let apiUrl = `/purchaseOrder/fetchPoAttachmentExcelData`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  fetchPoAttachmentExcelDataByPoToken(params:any):Promise<any>{
    let apiUrl = `/purchaseOrder/fetchPoAttachmentExcelDataByPoToken`;

    // Ensure purchaseOrderId matches the verified token's poId when possible
    const poId = this.poTokenAuth.getPoId();
    const requestBody = {
      ...params,
      ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
    };

    const token = this.poTokenAuth.getToken();
    const options = token
      ? { headers: new HttpHeaders().set('Authorization', 'Bearer ' + token) }
      : {};

    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

}
